import { useLayoutEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import GridSkeleton from 'components/Grid/GridSkeleton';
import { WaterfallRecalculationProps } from './WaterfallRecalculation.props';
import { WATERFALL_RECALCULATION_STYLES } from '../WaterfallLoadingSkeleton/WaterfallLoadingSkeleton.styles';

const WaterfallRecalculation = ({ children, isRecalculating, sx, ...props }: WaterfallRecalculationProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [cellContainers, setCellContainers] = useState<Element[]>([]);

  // Mount the existing GridSkeleton in each real cell; no copied animation or guessed table geometry.
  useLayoutEffect(() => {
    const cells = isRecalculating
      ? Array.from(containerRef.current?.querySelectorAll('.data-grid .cell.visible:not(.legend)') ?? [])
      : [];
    setCellContainers(previous =>
      previous.length === cells.length && previous.every((cell, index) => cell === cells[index]) ? previous : cells
    );
  }, [children, isRecalculating]);

  return (
    <Box
      {...props}
      ref={containerRef}
      sx={[...(Array.isArray(sx) ? sx : [sx]), ...(isRecalculating ? [WATERFALL_RECALCULATION_STYLES] : [])]}>
      {children}
      {isRecalculating &&
        cellContainers.map((cell, index) =>
          createPortal(
            <GridSkeleton className="waterfall-cell-skeleton" maxColumns={1} maxRows={1} />,
            cell,
            String(index)
          )
        )}
    </Box>
  );
};

export default WaterfallRecalculation;
